import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators,} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {
    MatCard,
    MatCardActions,
    MatCardContent,
    MatCardFooter,
    MatCardHeader,
    MatCardTitle,
} from '@angular/material/card';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatToolbar} from '@angular/material/toolbar';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {ClientService} from '@app/admin/client.service';
import {AuthService} from '@app/auth/auth.service';
import {InvitationService} from '@app/invitation/invitation.service';
import {StorageService} from '@app/shared/storage.service';
import {Observable, of} from 'rxjs';
import {catchError, mergeMap, tap} from 'rxjs/operators';

@Component({
    selector: 'frog-join',
    templateUrl: './join.component.html',
    styleUrls: ['./join.component.scss'],
    imports: [
        MatToolbar,
        RouterLink,
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardContent,
        ReactiveFormsModule,
        FormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatCardActions,
        MatButton,
        MatCardFooter,
        AsyncPipe,
    ],
})
export class JoinComponent implements OnInit {
    public error: string;
    public loading: boolean;
    public form: FormGroup;
    public invitation$: Observable<any>;
    private id: string;
    private code: string;

    constructor(
        private invitationService: InvitationService,
        private clientService: ClientService,
        private authService: AuthService,
        private storageService: StorageService,
        private formBuilder: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {
        this.error = null;
        this.loading = false;

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            email: '',
        });
    }

    ngOnInit(): void {
        this.invitation$ = this.activatedRoute.params.pipe(
            tap((params) => {
                this.id = params.id;
                this.code = params.code;
            }),
            mergeMap((params) => this.invitationService.getInvitation(params.id, params.code)),
            tap((invitation) => {
                if (invitation.user === null) {
                    this.form.get('email').setValidators([Validators.required, Validators.email]);
                } else {
                    this.form.setValue({
                        name: invitation.user.name,
                        email: '',
                    });
                }
            }),
            catchError((err) => {
                this.error = err.error.detail;
                return of(null);
            }),
        );
    }

    accept() {
        this.loading = true;
        this.invitationService
            .acceptInvitation(this.id, this.code, this.form.value.name, this.form.value.email)
            .subscribe({
                next: (data) => {
                    this.storageService.set('token', 'invite');
                    this.loading = false;
                    this.router.navigate(['/s', data.streamId]);
                },
                error: (error) => {
                    this.loading = false;
                    this.error = error.error.detail || error.message;
                    this.authService.logout().subscribe();
                },
            });
    }
}
